var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.MainContent,{attrs:{"title":"Nueva campaña de UPSELLING","subtitle":"Configura las reglas y condiciones de la campaña"}},[_c(_setup.FormUpselling,{attrs:{"initialForm":_setup.localForm},on:{"terminado":function($event){return _vm.$router.push({ name: 'back.upselling.index' })}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }